var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { NetworkClient } from './NetworkClient';
import { RelayUnreachable } from './UhstErrors';
var RELAYS_LIST_URL = 'https://raw.githubusercontent.com/uhst/relays/main/list.json';

var RelayUrlsProvider = function () {
  function RelayUrlsProvider(networkClient) {
    this.networkClient = networkClient !== null && networkClient !== void 0 ? networkClient : new NetworkClient();
  }

  RelayUrlsProvider.prototype.getRelayUrls = function (hostId) {
    return __awaiter(this, void 0, void 0, function () {
      var relays, prefix, _i, relays_1, relay, urls;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.networkClient.get(RELAYS_LIST_URL)];

          case 1:
            relays = _a.sent();

            if (hostId) {
              prefix = hostId.split('-')[0];

              for (_i = 0, relays_1 = relays; _i < relays_1.length; _i++) {
                relay = relays_1[_i];

                if (relay.prefix === prefix) {
                  return [2
                  /*return*/
                  , relay.urls];
                }
              } // there are no relays serving this prefix


              return [2
              /*return*/
              , []];
            }

            urls = [];
            relays.forEach(function (x) {
              return x.urls.forEach(function (url) {
                return urls.push(url);
              });
            });
            return [2
            /*return*/
            , urls];
        }
      });
    });
  };

  RelayUrlsProvider.prototype.getBestRelayUrl = function (hostId) {
    return __awaiter(this, void 0, void 0, function () {
      var relayUrls;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getRelayUrls(hostId)];

          case 1:
            relayUrls = _a.sent();
            return [2
            /*return*/
            , new Promise(function (resolve, reject) {
              var resolved = false;
              var failed = 0;

              if (relayUrls.length === 0) {
                reject(new RelayUnreachable());
              } else {
                relayUrls.sort(function () {
                  return Math.random() - Math.random();
                }).slice(0, Math.min(relayUrls.length, 10)).forEach(function (url) {
                  return __awaiter(_this, void 0, void 0, function () {
                    var response, e_1;
                    return __generator(this, function (_a) {
                      switch (_a.label) {
                        case 0:
                          _a.trys.push([0, 2,, 3]);

                          return [4
                          /*yield*/
                          , this.networkClient.post(url, ['action=ping', "timestamp=" + Date.now()])];

                        case 1:
                          response = _a.sent();

                          if (!resolved) {
                            resolve(url);
                            resolved = true;
                          }

                          return [3
                          /*break*/
                          , 3];

                        case 2:
                          e_1 = _a.sent();
                          failed++;

                          if (!resolved && failed == relayUrls.length) {
                            reject(e_1);
                          }

                          return [3
                          /*break*/
                          , 3];

                        case 3:
                          return [2
                          /*return*/
                          ];
                      }
                    });
                  });
                });
              }
            })];
        }
      });
    });
  };

  return RelayUrlsProvider;
}();

export { RelayUrlsProvider };